module.exports = __webpack_public_path__ + "static/media/mf_sip.06895f1a.svg";